import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "context";
import { QueryKeys, client } from "queryClient";
import { GlobalSettings } from "types";
import { GLOBAL_SETTINGS_ID } from "utils/constants";

export const useGlobalSettingsRead = () => {
  const authContext = useAuthContext();

  const { data: globalSettings, isLoading } = useQuery({
    queryKey: [QueryKeys.GlobalSettings],
    queryFn: async () => {
      const globalSettingsResponse = await client.models.GlobalSettings.get({
        id: GLOBAL_SETTINGS_ID,
      });

      authContext.setGlobalSettings(globalSettingsResponse.data);

      return globalSettingsResponse.data as GlobalSettings | null;
    },
  });

  return {
    globalSettings,
    isLoading,
  };
};
